module.exports = __webpack_public_path__ + "static/media/riverside_team.094085b9.jpg";